import type { PublicSeoLanguage } from './publicSeoPages';

const PRICE_ID_PATTERN = /^price_[A-Za-z0-9]+$/;
const PAYMENT_LINK_PATH_PATTERN = /^\/(en\/)?active\/(price_[A-Za-z0-9]+)\/?$/;
export const PAYMENT_LINK_CONTINUE_STATE_KEY = 'palenPaymentLinkContinueToCompany';

export interface PaymentLinkRoute {
  language: PublicSeoLanguage;
  priceId: string;
}

export function isStripePriceId(value: unknown): value is string {
  return typeof value === 'string' && PRICE_ID_PATTERN.test(value);
}

export function buildPaymentLinkPath(priceId: string, language: PublicSeoLanguage): string {
  if (!isStripePriceId(priceId)) throw new Error('Invalid Stripe price ID for payment link.');
  return `${language === 'en' ? '/en' : ''}/active/${priceId}`;
}

export function parsePaymentLinkPath(path: string): PaymentLinkRoute | null {
  const match = PAYMENT_LINK_PATH_PATTERN.exec(new URL(path, 'http://localhost').pathname);
  if (!match) return null;
  return { language: match[1] ? 'en' : 'fr', priceId: match[2] };
}

export function buildPaymentLinkTemplateSeoHeadMarkup(language: PublicSeoLanguage): string {
  const title = language === 'en' ? 'Palen subscription' : 'Abonnement Palen';
  const description = language === 'en'
    ? 'Subscribe to Palen without a free trial.'
    : 'Souscrivez l’abonnement Palen sans période d’essai.';
  return [
    `<title>${title}</title>`,
    '<meta name="robots" content="noindex,nofollow" />',
    `<meta name="description" content="${description}" />`,
  ].join('\n');
}

export function buildPaymentLinkSeoHeadMarkup(path: string, interval?: 'monthly' | 'annual'): string {
  const route = parsePaymentLinkPath(path);
  if (!route) throw new Error('Invalid payment link path.');
  const canonicalPath = buildPaymentLinkPath(route.priceId, route.language);
  const period = interval === 'monthly'
    ? route.language === 'en' ? 'monthly' : 'mensuel'
    : interval === 'annual'
      ? route.language === 'en' ? 'annual' : 'annuel'
      : '';
  const title = route.language === 'en'
    ? `Palen ${period ? `${period} ` : ''}subscription`
    : `Abonnement ${period ? `${period} ` : ''}Palen`;
  const description = route.language === 'en'
    ? `Subscribe to Palen${period ? ` ${period}` : ''} without a free trial.`
    : `Souscrivez l’abonnement Palen${period ? ` ${period}` : ''} sans période d’essai.`;
  return [
    `<title>${title}</title>`,
    '<meta name="robots" content="noindex,nofollow" />',
    `<meta name="description" content="${description}" />`,
    `<link rel="canonical" href="https://palen-adr.eu${canonicalPath}" />`,
  ].join('\n');
}
